// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__N36ka","headerWrap":"Header_headerWrap__FY3Ti","shrink":"Header_shrink__fm0u+"};